import { isTask } from 'common-data-handling';
import { identity, uniqBy } from 'lodash';
import React, { useCallback, useMemo } from 'react';
import { hasDisplayCategory } from '../../../../../../../data/filters/schedule/hasDisplayCategory';
import { useParentRounds } from '../../../../../../../data/hooks/schedule/useParentRounds/useParentRounds';
import { useUncategorizedEventSchedule } from '../../../../../../../data/hooks/schedule/useUncategorizedEventSchedule';
import GroupedProgramItems from '../../../../common/GroupedProgramItems';
import { mergeProgramAndSchedule } from '../../../../mergeProgramAndSchedule';
import useScheduleMeetings from '../../../../useScheduleMeetings/useScheduleMeetings';

// Shows the filtered schedule using the filter in the store

function FilteredScheduleTabContent(props) {
    const { event, hasFilter, filter: scheduleFilterFunction = identity, dateFilter = identity, meetingsFilter = identity, focusedRoundId } = props,
        filter = useCallback((session) => dateFilter(session) && !hasDisplayCategory(session) && scheduleFilterFunction(session), [scheduleFilterFunction, dateFilter]),
        sessions = useUncategorizedEventSchedule(event.id, {
            filter,
        }),
        rounds = useParentRounds(event.id, sessions),
        sessionsWithRounds = useMemo(() => uniqBy([...sessions, ...rounds], 'id'), [sessions, rounds]),
        meetings = useScheduleMeetings(event.id, {
            filter: useCallback((meeting) => dateFilter(meeting) && meetingsFilter(meeting), [dateFilter, meetingsFilter]),
        }),
        mergedItems = useMemo(() => mergeProgramAndSchedule(sessionsWithRounds, meetings), [sessions, rounds, meetings]);

    return <GroupedProgramItems event={event} items={mergedItems} focusedRoundId={focusedRoundId} expandRounds={hasFilter} />;
}

export default FilteredScheduleTabContent;
